import { type Profile, createProfile } from 'models';
import { useQuery } from 'query';
import { getProfile } from '../services';
import { getProfileQueryKey } from './keys';

export const useProfileQuery = (options?: { gcTime?: number; staleTime?: number; throwOnError?: boolean }) =>
  useQuery<Profile>({
    async queryFn() {
      const response = await getProfile();

      return createProfile(response.data);
    },
    queryKey: getProfileQueryKey(),
    refetchInterval: 15 * 60 * 1000,
    staleTime: 15 * 60 * 1000,
    ...options,
  });
